module.exports = __webpack_public_path__ + "img/hr-brown-asterisk-07.96fc55c0.png";